import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { Form } from "react-bootstrap";
import { login } from "../../actions/register";
import "../styles/reg.css";
import Axxella from "../images/Axxela.png";
import SignIn from "../images/Sign-In.png";
import { Loading } from "../elements/Loading";

const Login = () => {
  const [formData, setFormData] = useState({
    userName: "",
    email: "",
    password: "",
    loading: false,
  });
  const isAuthenticated = useSelector(
    (state) => state.register.isAuthenticated
  );
  const loading = useSelector((state) => state.register.loading);
  const gameId = useSelector((state) => state.register.user?.gameId);
  const params = useParams();
  const dispatch = useDispatch();
  const onChangeHandler = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    formData.gameId = params.gameId;
    setFormData({ ...formData, loading: true });
    dispatch(login(formData));
  };

  if (loading && formData.loading) {
    return <Loading />;
  }

  if (isAuthenticated && gameId) {
    return <Redirect to={`/game/${gameId}`} />;
  }

  return (
    <div
      className="im"
      style={{ backgroundImage: `url("${SignIn}")` }}
      alt="background"
    >
      {" "}
      {/*Background Image*/}
      <div className="row no-gutters">
        <div className="col-md-3 no-gutters"></div>
        <div className="col-md-6 no-gutters">
          <Form className="style1" onSubmit={onSubmit}>
            <div className="axxella">
              <img src={Axxella} alt="" className="axxella-image" />
            </div>
            <br></br>
            <br></br>
            <Form.Group controlId="formEmail">
              <Form.Control
                className="login-input"
                type="email"
                name="email"
                placeholder="Your Email Address"
                size="lg"
                required
                onChange={onChangeHandler}
              />
            </Form.Group>
            <Form.Group controlId="formPassword">
              <Form.Control
                className="login-input"
                type="password"
                name="password"
                placeholder="Your Password"
                size="lg"
                required
                onChange={onChangeHandler}
              />
            </Form.Group>
            <button type="submit" className="btn submit-login">
              SIGN IN
            </button>
          </Form>
        </div>
        <div className="col-md-3 no-gutters"></div>
      </div>
    </div>
  );
};

export default Login;
